import * as FAUCET_JSON from './abi/Faucet.json';
import * as FAUCETTOKEN_JSON from './abi/FaucetToken.json';
import * as ERC20_JSON from './abi/ERC20.json';

export const FAUCET_ABI = FAUCET_JSON.abi;
export const FAUCETTOKEN_ABI = FAUCETTOKEN_JSON.abi;
export const ERC20_ABI = ERC20_JSON.abi